import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import DashboardCard from './DashboardCard';
import {
  ListRow, RowMain, RowName, RowSub, RowSide, TypeChip, MoreLink,
} from '../styles';
import { TYPE_FOLD_COLOR } from '../constants';
import RowAvatar from './RowAvatar';

export function initialsOf(name) {
  return (name || '')
    .split(' ')
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toLocaleUpperCase('tr-TR');
}

export default function TodayOnLeaveCard({ slice, typeColors }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const data = slice.data;
  const items = data?.items || [];

  const fmtDate = (d) => new Date(d).toLocaleDateString(i18n.language, { day: 'numeric', month: 'short' });
  const remaining = (data?.totalCount || 0) - items.length;

  return (
    <DashboardCard
      cardKey="bugun-izinde"
      title={t('leaveDashboard.today.title')}
      meta={data ? t('leaveDashboard.today.meta', { count: data.totalCount, depts: data.departmentCount }) : null}
      span={6}
      spanMd={6}
      loading={slice.loading}
      empty={items.length === 0}
      emptyText={t('leaveDashboard.today.empty')}
    >
      <div>
        {items.map((item) => (
          <ListRow key={item.leaveId}>
            <RowAvatar src={item.profilePicture} name={item.fullName} initials={initialsOf(item.fullName)} />
            <RowMain>
              <RowName>{item.fullName}</RowName>
              <RowSub>{[item.department, item.location].filter(Boolean).join(' · ')}</RowSub>
            </RowMain>
            <RowSide>
              <TypeChip $bg={typeColors.get(item.leaveVariationId) || TYPE_FOLD_COLOR}>
                {item.leaveVariationName}
              </TypeChip>
              <RowSub>
                {item.isHourly
                  ? t('leaveDashboard.today.hourly', { hours: item.cost })
                  : t('leaveDashboard.today.dayOf', { day: item.dayIndex, total: item.totalDays })}
                {' · '}
                {t('leaveDashboard.today.returnsOn', { date: fmtDate(item.returnDate) })}
              </RowSub>
            </RowSide>
          </ListRow>
        ))}
        {remaining > 0 && (
          <MoreLink type="button" onClick={() => history.push('/all-leaves')}>
            {t('leaveDashboard.today.moreCount', { count: remaining })}
          </MoreLink>
        )}
      </div>
    </DashboardCard>
  );
}
